import type { FunctionComponent } from "react";
import { useCallback } from "react";
import classNames from "classnames";
import { CasinoIconName } from "@ppb/the-wall-icons";
import { GenericIcon } from "@ppb/the-wall-icons/GenericIcon/GenericIcon";

import type { PromoButtonViewModel } from "./PromoButton.types";
import styles from "./PromoButton.web.css";

export const PromoButton: FunctionComponent<PromoButtonViewModel> = ({
  isSelected,
  disabled = false,
  onPress,
  promoIconName = CasinoIconName.PROMOTIONS,
}) => {
  const handleOnPress = useCallback(() => {
    if (onPress && !disabled) {
      onPress(isSelected);
    }
  }, [onPress, disabled, isSelected]);

  const promoButtonStyle = classNames(styles.container, {
    [styles.selected]: isSelected && !disabled,
    [styles.disabled]: disabled,
  });

  return (
    <button className={promoButtonStyle} onClick={handleOnPress} disabled={disabled}>
      <span className={styles.icon}>
        <GenericIcon name={promoIconName} />
      </span>
    </button>
  );
};
